import styled from "styled-components/macro";

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  position: relative;
  margin: 0 auto;
  
  .swiper {
    padding-bottom: 40px;
  }
  
  .swiper-wrapper {
    display: flex;
  }
  
  .swiper-pagination {
    bottom: 0;
  }
  
  .swiper-slide {
    height: auto;
    width: 384px !important;
    margin-right: 24px !important;
  }

  @media (max-width: 1439px) {
    .swiper-wrapper {
      display: flex !important;
      justify-content: center !important;
    }
    .swiper-slide {
      width: 325px !important;
      margin-right: 12px !important;
    }
  }

  @media (max-width: 979px) {
    .swiper-wrapper {
      justify-content: flex-start !important;
    }
    .swiper-slide {
      width: 246px !important;
      margin-right: 12px !important;
    }
  }

  .swiper-wrapper .swiper-slide:last-child {
    margin-right: 0 !important;
  }

  .swiper-pagination-bullet {
     background-color: rgba(85, 116, 159, 1);
     width: 38px;
     height: 2px;
     border-radius: 0;
   }

   .swiper-pagination-bullet-active {
      background-color: #55749F;
      width: 38px;
      height: 2px;
      border-radius: 0;
   }
`;

export const Card = styled.article`
  border-radius: 24px;
  border: 1px solid #B4B4B4;
  overflow: hidden;
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const CardHeader = styled.div<{ color?: string}>`
  width: 100%;
  height: 25px;  
  background-color: ${({ color }) => color };
`;

export const CategoryContainer = styled.div`
  padding: 0 24px;
  margin-top: 24px;
  display: flex;
  align-items: center;
  height: 22px;

  @media (max-width: 979px) {
    padding: 0 16px;
  }
`;

export const TitleContainer = styled.div`
  padding: 0 24px;
  margin-bottom: 24px;
  height: 68px;

  @media (max-width: 979px) {
    padding: 0 16px;
  }
`;

export const PriceContainer = styled.div`
  height: 173px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;

  @media (max-width: 979px) {
    padding: 16px;
  }
`;

export const ButtonContainer = styled.div`
  padding: 24px;
  margin-top: auto;
`;

export const Circle = styled.div<{ color?: string}>`
  width: 8px;
  min-width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  background-color: ${({ color }) => color };
`;

export const Category = styled.span`
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;
  white-space: nowrap;

  @media (max-width: 979px) {
    font-size: 13px;
  }
`;

export const Title = styled.span<{customFontSize?: boolean}>`
  width: 100%;
  font-size: 35px;
  font-family: "Cormorant Infant", sans-serif;
  font-weight: 600;
  display: block;
  line-height: 100%;

  @media (max-width: 979px) {
    font-size: 30px;
    ${({ customFontSize }) => customFontSize && "font-size: 24px;" }
  }
`;

export const Divider = styled.div`
  width: 100%;
  border-top: 1px dashed #B4B4B4;
`;

export const Description = styled.p`
  font-size: 18px;
  line-height: 20px;
  height: 224px;
  padding: 24px;

  @media (max-width: 979px) {
    font-size: 15px;
    padding: 16px;
  }
`;

export const Meeting = styled.span`
  font-size: 18px;
  
  @media (max-width: 979px) {
    font-size: 15px;
  }
`;

export const Price = styled.span<{textLength:number}>`
  font-size: ${(
      props => 35 
          - (props.textLength > 8 ? 3 : 0) 
          - (props.textLength > 10 ? 2 : 0)
          - (props.textLength > 11 ? 2 : 0)
  )}px;
  font-family: "Cormorant Infant", sans-serif;
    
  @media (max-width: 979px) {
    font-size: 30px;
  }
`;

export const Tag = styled.span`
  background-color: #BFDCF5;
  border-radius: 22px;
  font-size: 16px;
  line-height: 100%;
  font-weight: 500;
  padding: 8px 16px;
  width: max-content;
  margin-top: auto;
`;

export const Button = styled.button`
  color: #fff;
  font-weight: 500;
  background-color: #141414;
  border: 1px solid #141414;
  height: 54px;
  cursor: pointer;
  border-radius: 30px;
  font-size: 18px;
  line-height: 18px;
  text-decoration: none;
  transition: 0.2s;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  
  &:hover {
    background-color: #fff;
    color: #141414;
    transition: 0.2s;
    border: 1px solid #141414;
  }
`;
